module.exports = __webpack_public_path__ + "assets/chuhangshijian.9b38381b.svg";